import { Route } from "@angular/router";
import { CreateOperationComponent } from "./create-operation.component";

export const createOperationRoute: Route[] = [
    {
        path: "create",
        component: CreateOperationComponent,
    },
];
